// extracted by mini-css-extract-plugin
module.exports = {"root":"Privacy_root__3QL_j","header":"Privacy_header__2Py4I","date":"Privacy_date__1Csgm"};